<template>
  <q-card
    class="q-pa-none"
    style="height: 100vh; display: flex; flex-direction: column"
  >
    <q-toolbar class="bg-primary text-white shadow-2 toolbar-no-pad">
      <div class="row items-center">
        <q-avatar
          square
          size="36px"
          class="q-mr-sm bg-white text-primary"
        >
          <q-icon
            name="picture_as_pdf"
            size="22px"
          />
        </q-avatar>

        <q-toolbar-title
          class="column q-mr-md q-pa-none"
          style="max-width: 350px; overflow: hidden; text-overflow: ellipsis;"
        >
          <div class="text-subtitle2 ellipsis">
            Gestão Tributária - {{ nomeArquivo }}
          </div>
          <span style="font-size: 10px">{{ desLogin }} - {{ getNome() }}</span>
        </q-toolbar-title>
      </div>

      <!-- Grupo de botões forçado à direita -->
      <div style="margin-left: auto; display: flex; align-items: center; gap: 6px;">
        <q-btn
          flat
          round
          dense
          icon="file_download"
          color="orange"
          @click="baixarPdf"
          :title="'Baixar ' + nomeArquivo"
        />
        <q-btn
          flat
          round
          dense
          icon="print"
          color="orange"
          @click="imprimirPdf"
          title="Imprimir PDF"
        />

        <q-separator
          vertical
          color="white"
          spaced
        />

        <q-btn
          flat
          round
          dense
          icon="zoom_in"
          @click="aumentarZoom"
          title="Aumentar Zoom"
        />
        <q-btn
          flat
          round
          dense
          icon="zoom_out"
          @click="diminuirZoom"
          title="Diminuir Zoom"
        />
        <q-btn
          flat
          round
          dense
          icon="fit_screen"
          @click="ajustarTamanhoTela"
          title="Ajustar para tela"
        />
      </div>
    </q-toolbar>

    <div style="flex: 1; position: relative">
      <iframe
        id="relatorios"
        class="iframe"
        :key="objExportacao.urlPdf"
        :src="this.objExportacao.urlPdf"
        width="100%"
        height="100vh"
        title="Visualizador de Relatório em PDF"
      ></iframe>
    </div>
  </q-card>
</template>

<script>
import util from 'components/util/util'

export default {
  data () {
    return {
      desLogin: '',
      nomeArquivo: '',
      objExportacao: {
        arquivoConteudo: '', // Base64
        nomRelatorioDownload: ''
      },
      urlBlob: ''
    }
  },
  methods: {
    ajustarTamanhoTela () {
      this.objExportacao.urlPdf = this.objExportacao.urlPdf + '&view=fitH'
    },
    pegarZoomAtual () {
      const hash = this.objExportacao.urlPdf.split('#')[1] // "toolbar=0&zoom=150"
      const params = new URLSearchParams(hash)
      return params.get('zoom')
    },
    diminuirZoom () {
      let zoom = this.pegarZoomAtual()
      let novoZoom = parseInt(zoom) - 10
      this.objExportacao.urlPdf = this.objExportacao.urlPdf.replace('&zoom=' + zoom, '&zoom=' + novoZoom).replace('&view=fitH', '')
    },
    aumentarZoom () {
      let zoom = this.pegarZoomAtual()
      let novoZoom = parseInt(zoom) + 10
      this.objExportacao.urlPdf = this.objExportacao.urlPdf.replace('&zoom=' + zoom, '&zoom=' + novoZoom).replace('&view=fitH', '')
    },
    baixarPdf () {
      const link = document.createElement('a')
      link.href = this.objExportacao.urlPdf
      link.download = this.nomeArquivo
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    imprimirPdf () {
      const iframe = document.querySelector('.iframe')
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
      }
    },
    getNome () {
      const nomeCompleto = this.$login.getNomUsuario().trim().split(/\s+/)
      const primeiroNome = nomeCompleto[0]
      const ultimoNome = nomeCompleto[nomeCompleto.length - 1]
      if (primeiroNome === ultimoNome) {
        return primeiroNome
      }

      return primeiroNome + ' ' + ultimoNome
    }
  },
  mounted () {
    this.objExportacao = JSON.parse(localStorage.getItem('RELATORIO_PDF'))
    this.objExportacao.urlPdf =
      this.objExportacao.urlPdf + '#toolbar=0&zoom=150'
    this.nomeArquivo =
      this.objExportacao.nome || 'Relatorio.pdf'
    this.desLogin = util.formatarCpfCnpj(this.$login.getDesLogin())
  }
}
</script>

<style scoped>
.iframe {
  width: 100%;
  height: calc(100vh - 56px); /* ajusta altura para toolbar */
  border: none;
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.q-toolbar {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.toolbar .dropup.widSettings li:nth-child(4),
.toolbar .dropup.widSettings li:nth-child(5) {
  display: none !important;
}
.toolbar .dropup.widSettings li:nth-child(5) {
  display: none !important;
}

.toolbar-no-pad {
  padding-left: 8px; /* opcional: reduz padding padrão */
  padding-right: 8px; /* reduzir para chegar mais perto da borda */
}

/* garante que o q-toolbar-title não introduza padding interno */
.q-toolbar .q-toolbar-title.q-pa-none {
  padding-left: 0;
  padding-right: 0;
}

/* se ainda sobrar um pequeno gap por causa do container pai, force overflow */
.q-toolbar {
  width: 100%;
  box-sizing: border-box;
}
</style>
